// extracted by mini-css-extract-plugin
export default {"root":"AdminActionLogManagment_root__3v791"};